module.exports = __webpack_public_path__ + "media/images/company/cp17-22867422317d3daa7ee8c2ff059dd88f.png";